module.exports = __webpack_public_path__ + "img/responsive hospitium-02.9c658388.jpg";